module.exports = __webpack_public_path__ + "static/media/piggy-bank.90e174a8.svg";